import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff, HeartPulse, LoaderCircle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";

const Login = () => {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, senha);
    if (res.ok) {
      navigate("/");
    } else {
      setError(res.error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-slate-50 to-blue-100">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-blue-600 text-white mb-4 shadow-lg shadow-blue-200">
              <HeartPulse className="w-7 h-7" />
            </div>
            <h1 className="text-xl font-bold text-slate-800">Casa de Repouso São Jorge</h1>
            <p className="text-sm text-slate-400 mt-1">Sistema de Gestão</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-600 mb-1.5 block">E-mail ou CPF</label>
              <div className="flex items-center gap-2.5 px-3.5 rounded-lg border border-slate-200 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition">
                <Mail className="w-[18px] h-[18px] text-slate-400" />
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="e-mail ou CPF (só números)"
                  data-testid="login-email-input"
                  className="flex-1 py-3 bg-transparent outline-none text-sm text-slate-700"
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-slate-600 mb-1.5 block">Senha</label>
              <div className="flex items-center gap-2.5 px-3.5 rounded-lg border border-slate-200 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition">
                <Lock className="w-[18px] h-[18px] text-slate-400" />
                <input
                  type={show ? "text" : "password"}
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="••••••••"
                  className="flex-1 py-3 bg-transparent outline-none text-sm text-slate-700"
                  required
                />
                <button type="button" onClick={() => setShow(!show)} className="text-slate-400 hover:text-slate-600">
                  {show ? <EyeOff className="w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
                </button>
              </div>
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3.5 py-2.5">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg"
            >
              {loading ? <LoaderCircle className="w-5 h-5 animate-spin" /> : "Entrar"}
            </Button>

            <button type="button" className="w-full text-center text-sm text-blue-600 hover:text-blue-700 mt-1">
              Recuperar senha
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
